import type { Path, Element } from 'slate';

import * as RDMD from '@readme/markdown-legacy';
import { Editor, Text, Transforms } from 'slate';

import { isListItem } from '../ListItem/shared';
import { isParagraph, type as paragraphType } from '../Paragraph/shared';

import { type } from './shared';

export const convertToBlockquote = (editor: Editor, attrs = {}) => {
  const entry = Editor.above(editor, {
    match: node => Editor.isBlock(editor, node as Element),
  });

  if (!entry) return;
  const [block, path] = entry;
  const node = { type, ...attrs } as Element;

  if (isListItem(block)) {
    Editor.withoutNormalizing(editor, () => {
      Transforms.wrapNodes(editor, { type: paragraphType } as Element, {
        match: n => Text.isText(n) || (!Editor.isEditor(n) && editor.isInline(n)),
      });
      Transforms.wrapNodes(editor, node, { match: isParagraph });
    });
  } else {
    Transforms.wrapNodes(editor, node, { at: path });
  }
};

type calloutTypes = 'default' | 'error' | 'info' | 'okay' | 'warn';

export const convertToCallout = (editor: Editor, calloutType: calloutTypes) => {
  const icon = RDMD.utils.calloutIcons[calloutType][0];

  convertToBlockquote(editor, { icon, theme: calloutType, empty: false });
};

export const convertCalloutIcon = (editor: Editor, nameOrIcon: string, path: Path, theme?: calloutTypes) => {
  const icon = RDMD.Owlmoji.nameToEmoji[nameOrIcon] ?? nameOrIcon;

  Transforms.setNodes(editor, { icon, theme }, { at: path });
};

export const convertToCalloutDefault = (editor: Editor) => convertToCallout(editor, 'default');
export const convertToCalloutError = (editor: Editor) => convertToCallout(editor, 'error');
export const convertToCalloutInfo = (editor: Editor) => convertToCallout(editor, 'info');
export const convertToCalloutSuccess = (editor: Editor) => convertToCallout(editor, 'okay');
export const convertToCalloutWarning = (editor: Editor) => convertToCallout(editor, 'warn');

export default {
  convertToBlockquote,
  convertToCallout,
  convertToCalloutDefault,
  convertToCalloutError,
  convertToCalloutInfo,
  convertToCalloutSuccess,
  convertToCalloutWarning,
  convertCalloutIcon,
};
